import React from "react";
import { useTranslation } from "react-i18next";

import { Chip } from "@mui/material";

import { AggregatedAlertType } from "@/pages/browser-defender/demo/passwordMisuseUpdated/service/types";

type AlertTypeChipProps = {
  alertType: AggregatedAlertType;
};

const PasswordMisuseAlertTypeChip: React.FC<AlertTypeChipProps> = ({
  alertType,
}) => {
  const { t } = useTranslation();

  const getLabel = () => {
    switch (alertType) {
      case "phishing":
        return t("Phishing");
      case "reuse":
        return t("Reuse");
      case "mixed":
        return t("Phishing+Reuse");
      default:
        return t("Unknown");
    }
  };

  const isPhishingOrMixed = alertType === "phishing" || alertType === "mixed";

  return (
    <Chip
      label={getLabel()}
      size="small"
      sx={{
        backgroundColor: isPhishingOrMixed
          ? "rgba(244, 67, 54, 0.08)"
          : "rgba(158, 158, 158, 0.08)",
        color: isPhishingOrMixed ? "#F44336" : "#9E9E9E",
        fontWeight: "normal",
        borderRadius: "16px",
        padding: "0 0px",
        fontSize: "0.75rem",
        border: `1px solid ${isPhishingOrMixed ? "#F44336" : "#9E9E9E"}`,
      }}
    />
  );
};

export default PasswordMisuseAlertTypeChip;
